 
import React, {useContext} from 'react';
import {BridleContext} from './../BridleContextProvider';
import {getAttributesGroupedInDisplayOrder, getSortOrder, orderMap} from '../HelperFunctions';
import Toolbar from '../components/Toolbar';
import SectionInfo from './../components/SectionInfo';
import Buttons from './../components/Buttons';
import Page from '../components/Page';

const Crown = () => {
    const {products, options} = useContext(BridleContext);
    const pieces = getSortOrder(products, orderMap.Crown);
    const productId = options.Crown.productId;
    const attributesInOrder = getAttributesGroupedInDisplayOrder(pieces.attributeValues);

    return (
        <div className="bridle-page-content">
            <Toolbar pageName="Crown" />
            <SectionInfo section="Crown" page="2" />
            <Page
                attributes={attributesInOrder}
                pageName="Crown"
                pieces={pieces}
                productId={productId}
                sizeGuide="crownpiece"
            />
            <Buttons back="/color" next="/browband" disableButton={productId === ''} />
        </div>
    );
};

export default Crown;
